import { createEvent, createStore, sample } from 'effector'
import { F, T } from '~/shared/helpers'
import { init, initSearchResultsPage } from '../root/model'
import { resetSearchOnProfileSwitch } from './resetOnProfileSwitch'

/** Fired when user leaves regular search page (initial or results) */
export const leftRegularSearchPage = createEvent()

export const $isOnRegularSearchPage = createStore(false)
  .on([init, initSearchResultsPage], T)
  .on(leftRegularSearchPage, F)

sample({
  clock: resetSearchOnProfileSwitch,
  target: leftRegularSearchPage,
})
